import React from "react";
import "./Text.css";

export default function Text({
  children,
  as: Component = "p",
  size = "md",
  tone = "default",
  className = "",
  ...props
}) {
  return (
    <Component
      className={["ko-text", `ko-text--${size}`, `ko-text--${tone}`, className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
